import { createLocationState } from "@rangojs/router";

export const CartFlash = createLocationState<{ text: string }>({
  flash: true,
});
